module.exports = function getBoolFromVar(value) {
	return value === "true" || value === true || value === 1 || value === "1";
};
